"use client"

import React, { useState } from "react"
import { useRouter } from "next/navigation"
import { addArticleToCurrentBasketAction } from "@/actions/basketActions"
import { LoaderCircle, ShoppingCartIcon } from "lucide-react"

import { getLinkWithPrefixFromURLAndLocale } from "@/lib/link-utils/link-utils"
import { OrderLineItemData } from "@/lib/storefront/order/order"
import { trackAddToBasket } from "@/lib/tracking/tracking-helper"
import { Button } from "@/components/ui/components"

export default function ReorderAllButtonClient(props: {
  items?: Promise<OrderLineItemData[]>
  itemsSync?: OrderLineItemData[]
  label_buy_again: string
  label_is_adding: string
  sbLocale: string
}) {
  const [loading, setLoading] = useState(false)
  const router = useRouter()

  const addAllToCart: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    // stop link from outer box to react
    e.stopPropagation()
    e.preventDefault()

    setLoading(true)
    let items = props.itemsSync
    if (props.items) items = await props.items
    if (!items) return

    try {
      await Promise.all(
        items.map((item) => {
          return addArticleToCurrentBasketAction(item.product?.id ?? "", item.orderLineItem.quantity.value).then(
            (res) => {
              trackAddToBasket(res.isoLocale, res.isB2B, res.product, res.prices, res.quantity)
            }
          )
        })
      )
      router.push(getLinkWithPrefixFromURLAndLocale("/basket/overview", props.sbLocale))
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button size={"smNoGrow"} variant={"outline"} className="bg-primary text-white" onClick={addAllToCart}>
      {loading ? (
        <LoaderCircle className={"motion-safe:animate-spin"} />
      ) : (
        <ShoppingCartIcon className={"mr-1 inline-block size-4"} />
      )}
      <span className={"ml-2"}>{loading ? props.label_is_adding : props.label_buy_again}</span>
    </Button>
  )
}
